const env = process.env.ENVIRONMENT !== 'PDN' ? 'DEV' : 'PDN'

let url = {
  DEV: 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol',
  PDN: 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol',
}[env]

//forum
export const replyForum = url + '/competition/api/v1/forum/saveForumReply'
export const getRepliesByForum =
  url + '/competition/api/v1/forum/getRepliesByForumId'
export const getForumsByConcourse =
  url + '/competition/api/v1/forum/getForumsByConcourseId'
export const getLikeByCommentId =
  url + '/competition/api/v1/forum/getLikeByUser'
export const saveLikeByCommentId =
  url + '/competition/api/v1/forum/SaveLikeCommentary'
export const getReferralsByUser = url + '/competition/api/v1/referrals'
